import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export const PortalansichtBanner = () => {
  const { portalansicht, portalansichtBeenden } = useAuth();
  if (!portalansicht) return null;
  const beenden = () => { const nr = portalansicht.mandanten_nr; portalansichtBeenden(); window.location.assign(`/kanzlei/mandanten/${nr}`); };
  return (
    <div className="fixed bottom-[88px] left-1/2 -translate-x-1/2 z-[60] w-[calc(100%-1.5rem)] max-w-2xl rounded-full bg-[#b8893d] text-[#0B1724] text-xs shadow-lg" data-testid="portalansicht-banner">
      <div className="px-4 h-9 flex items-center gap-2">
        <Eye className="w-4 h-4" />
        <span className="truncate"><b>Portalansicht</b> · {portalansicht.name} (M-{portalansicht.mandanten_nr}) · nur lesen, jeder Aufruf wird protokolliert</span>
        <button type="button" onClick={beenden} className="ml-auto inline-flex items-center gap-1 h-6 px-2 rounded-full bg-[#0B1724] text-white" data-testid="portalansicht-beenden"><X className="w-3 h-3" /> Beenden</button>
      </div>
    </div>
  );
};

export const PortalansichtButton = ({ mandant }) => {
  const { portalansichtStarten, echterUser } = useAuth();
  const navigate = useNavigate();
  if (!['admin', 'kanzlei_mitarbeiter'].includes(echterUser?.role)) return null;
  return (
    <button type="button" onClick={() => { portalansichtStarten(mandant); navigate('/dashboard'); }} data-testid="m360-portalansicht"
      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-[11px] tracking-wider border border-[#b8893d] text-[#b8893d] hover:bg-[#b8893d] hover:text-white transition-colors">
      <Eye className="w-3.5 h-3.5" /> PORTALANSICHT
    </button>
  );
};
